import { NoMatchPage } from "components/NoMatchPage";
import { FC } from "react";
import { Route, Routes } from "react-router-dom";
import JobDetails from "./jobDetails";

const Router: FC = () => {
  return (
    <Routes>
      <Route path="/:token/*" element={<JobDetails />} />
      <Route path="*" element={<NoMatchPage />} />
    </Routes>
  );
};
export default Router;
